import { render, staticRenderFns } from "./explain-filters.component.vue?vue&type=template&id=310b22fb&scoped=true"
import script from "./explain-filters.component.vue?vue&type=script&lang=ts"
export * from "./explain-filters.component.vue?vue&type=script&lang=ts"
import style0 from "./explain-filters.component.vue?vue&type=style&index=0&id=310b22fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310b22fb",
  null
  
)

export default component.exports